import { render, staticRenderFns } from "./m-folder-propries.vue?vue&type=template&id=7cc1be73&"
import script from "./m-folder-propries.vue?vue&type=script&lang=js&"
export * from "./m-folder-propries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports